import dynamic from "next/dynamic";
import { Modal } from "../lib/features/modal/modal.types";

const TryItOnModal = dynamic(
  () => import("../components/elements/modal/TryItOnModal"),
);
const TryItOnComplateModal = dynamic(
  () => import("../components/elements/modal/TryItOnComplateModal"),
);
const OutfitCompleteModal = dynamic(
  () => import("../components/elements/modal/OutfitCompleteModal"),
);
const ConsentModal = dynamic(
  () => import("../components/elements/modal/ConsentModal"),
);
const AddressModal = dynamic(
  () => import("../components/elements/modal/AddressModal"),
);
const CollectionUpsertModal = dynamic(
  () => import("../components/elements/modal/CollectionUpsertModal"),
);
const AddToCollectionModal = dynamic(
  () => import("../components/elements/modal/AddToCollectionModal"),
);
const QRLoginModal = dynamic(
  () => import("../components/elements/modal/QRLoginModal"),
);
const GenderSelectionModal = dynamic(
  () => import("../components/elements/modal/GenderSelectionModal"),
);
const CouponsModal = dynamic(
  () => import("../components/elements/modal/CouponsModal"),
);
const ProductReviewModal = dynamic(
  () => import("../components/elements/modal/ProductReviewModal"),
);
const OrderReviewModal = dynamic(
  () => import("../components/elements/modal/OrderReviewModal"),
);
const PointInfoModal = dynamic(
  () => import("../components/elements/modal/PointInfoModal"),
);
const PointCalculationModal = dynamic(
  () => import("../components/elements/modal/PointCalculationModal"),
);
const PhotoReviewsModal = dynamic(
  () => import("../components/elements/modal/PhotoReviewsModal"),
);
const ReportModal = dynamic(
  () => import("../components/elements/modal/ReportModal"),
);
const AskQuestionModal = dynamic(
  () => import("../components/elements/modal/AskQuestionModal"),
);
const PaymentModal = dynamic(
  () => import("../components/elements/modal/PaymentModal"),
);
const FollowRewardModal = dynamic(
  () => import("../components/elements/modal/FollowRewardModal"),
);
const StoreVideoModal = dynamic(
  () => import("../components/elements/modal/StoreVideoModal"),
);
const ReviewDetailModal = dynamic(
  () => import("../components/elements/modal/ReviewDetailModal"),
);
const PhoneVerificationModal = dynamic(
  () => import("../components/elements/modal/PhoneVerificationModal"),
);
const SpinWheelModal = dynamic(
  () => import("../components/elements/modal/SpinWheelModal"),
);
const AddressPickerModal = dynamic(
  () => import("../components/elements/modal/AddressPickerModal"),
);
const CheckoutOtpModal = dynamic(
  () => import("../components/elements/modal/CheckoutOtpModal"),
);
const PopupModal = dynamic(
  () => import("../components/elements/modal/PopupModal"),
);
const AuthRequiredModal = dynamic(
  () => import("../components/elements/modal/AuthRequiredModal"),
);
const SizePickerModal = dynamic(
  () => import("../components/elements/modal/SizePickerModal"),
);
const ProductCardCartModal = dynamic(
  () => import("../components/elements/modal/ProductCardCartModal"),
);
const FilterMinimumWarningModal = dynamic(
  () => import("../components/elements/modal/FilterMinimumWarningModal"),
);
const AddedToCartModal = dynamic(
  () => import("../components/elements/modal/AddedToCartModal"),
);
const CashOnDeliveryShippingModal = dynamic(
  () => import("../components/elements/modal/CashOnDeliveryShippingModal"),
);

export const modalRegistery: Modal[] = [
  {
    name: "try-it-on",
    element: TryItOnModal,
    size: "2xl",
  },
  {
    name: "try-it-on-complate",
    element: TryItOnComplateModal,
    size: "5xl",
  },
  {
    name: "outfit-complete",
    element: OutfitCompleteModal,
    size: "4xl",
  },
  {
    name: "consent",
    element: ConsentModal,
    size: "lg",
    className: "overflow-hidden flex flex-col",
  },
  {
    name: "address",
    element: AddressModal,
    size: "2xl",
    className: "overflow-hidden flex flex-col p-0",
  },
  {
    name: "upsert-collection",
    element: CollectionUpsertModal,
    size: "3xl",
  },
  {
    name: "add-to-collection",
    element: AddToCollectionModal,
    size: "lg",
  },
  {
    name: "qr-login",
    element: QRLoginModal,
    size: "lg",
  },
  {
    name: "gender-selection",
    element: GenderSelectionModal,
    size: "lg",
  },
  {
    name: "coupons",
    element: CouponsModal,
    size: "2xl",
  },
  {
    name: "product-review",
    element: ProductReviewModal,
    size: "2xl",
  },
  {
    name: "order-review",
    element: OrderReviewModal,
    size: "2xl",
  },
  {
    name: "point-info",
    element: PointInfoModal,
    size: "lg",
    title: "Puan Bilgisi",
  },
  {
    name: "point-calculation",
    element: PointCalculationModal,
    size: "lg",
    title: "Puan Hesaplama Örneği",
  },
  {
    name: "photo-reviews",
    element: PhotoReviewsModal,
    size: "5xl",
  },
  {
    name: "report",
    element: ReportModal,
    size: "md",
  },
  {
    name: "ask-question",
    element: AskQuestionModal,
    size: "lg",
  },
  {
    name: "payment",
    element: PaymentModal,
    size: "2xl",
    title: "Ödeme",
  },
  {
    name: "follow-reward",
    element: FollowRewardModal,
    size: "md",
    title: "",
  },
  {
    name: "store-video",
    element: StoreVideoModal,
    size: "4xl",
    title: "",
  },
  {
    name: "review-detail",
    element: ReviewDetailModal,
    size: "4xl",
    title: "",
  },
  {
    name: "phone-verification",
    element: PhoneVerificationModal,
    size: "md",
    title: "Telefon Doğrulama",
  },
  {
    name: "spin-wheel",
    element: SpinWheelModal,
    size: "xl",
  },
  {
    name: "address-picker",
    element: AddressPickerModal,
    size: "lg",
    title: "Adres Seç",
    className: "overflow-hidden flex flex-col p-0",
  },
  {
    name: "checkout-otp",
    element: CheckoutOtpModal,
    size: "sm",
    title: "Telefon Doğrulama",
  },
  {
    name: "popup",
    element: PopupModal,
    size: "md",
    title: "",
  },
  {
    name: "auth-required",
    element: AuthRequiredModal,
    size: "md",
    title: "",
  },
  {
    name: "size-picker",
    element: SizePickerModal,
    size: "md",
    title: "Renk ve Beden Seçin",
  },
  {
    name: "product-card-cart",
    element: ProductCardCartModal,
    size: "md",
    title: "Renk ve Beden Seçin",
  },
  {
    name: "filter-minimum-warning",
    element: FilterMinimumWarningModal,
    size: "sm",
    title: "",
  },
  {
    name: "added-to-cart",
    element: AddedToCartModal,
    size: "sm",
    title: "SEPETE EKLENDİ",
  },
  {
    name: "cash-on-delivery-shipping",
    element: CashOnDeliveryShippingModal,
    size: "sm",
    title: "",
  },
];

export type ModalName = (typeof modalRegistery)[number]["name"];
export default modalRegistery;
